// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import  Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import Loading from 'vue-loading-overlay';

import Datetime from './views/date_time/index.js'
//import 'vue-datetime/dist/vue-datetime.css'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import "@fontsource/roboto";


import { Settings } from 'luxon'


import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

//import VueTheMask from 'vue-the-mask'
Settings.defaultLocale = 'de';



Vue.use(Datetime);

Vue.use(Loading, {
  color: 'blue',
  canCancel: false,
  height: 100,
  width: 100,
  opacity: 0.7
});

// todo
// cssVars()

//Vue.use(VueTheMask)

Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(VueCookies);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  vuetify
});


Vue.http.interceptors.push(function(request) {
  request.credentials=true;
});
